/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import Header from "../../components/Header";
import { tokens } from "../../theme";
import { tableStyle } from "../../components";
import MenuItemForm from "./MenuItemForm";
import MenuItemTable from "./MenuItemTable";

import {
  addNewMenuItem,
  listAllMenuItems,
  resetAllMenuItems,
  updateMenuItem,
} from "../../store/actions/menuItemActions";

const MenuItems = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);


  const {
  isLoading,
  menuItemsList,
  showViewMore,
  hotelProfileId,
  pageNumber,
  totalCount,
} = useSelector(({ loading, menuItems, registration }) => {
  const menuItemsState = menuItems?.menuItems || {};

  return {
    isLoading: loading,
    menuItemsList: menuItemsState?.list || [],
    showViewMore: menuItemsState?.showViewMore ?? false,
    hotelProfileId: registration?.hotelProfile?._id,
    pageNumber: menuItemsState?.pageNumber ?? 1,
    totalCount: menuItemsState?.totalCount ?? 0,
  };
});


  // ✅ Fetch menu items on mount
  useEffect(() => {
    document.title = "Menu Items";
    dispatch(resetAllMenuItems());
    fetchMoreMenuItems();
  }, [dispatch]);

  const fetchMoreMenuItems = () => {
    dispatch(listAllMenuItems({}));
  };

  // ✅ Modal controls
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setEditMode(false);
    setSelectedItem(null);
    setOpen(false);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setEditMode(true);
    setOpen(true);
  };

  // ✅ Form submission (Add / Update)
  const handleFormSubmit = async (values) => {
    try {
      if (editMode&& values._id) {
        // Update functionality can be added later
        dispatch(updateMenuItem(values));
         dispatch(resetAllMenuItems());
          fetchMoreMenuItems();
        // toast.info("Edit functionality not yet implemented");
      } else {
        const result = await dispatch(addNewMenuItem(values));
        if (result === true) {
          toast.success("Menu item added successfully");
          dispatch(resetAllMenuItems());
          fetchMoreMenuItems();
        } else {
          toast.error("Failed to add menu item");
        }
      }
      handleClose();
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  // ✅ Modal styling
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: smScreen ? 400 : "90%",
    bgcolor: colors.primary[400],
    outline: "none",
    boxShadow: 24,
    p: 2,
  };

  return (
    <Box m="20px" mb={15}>
      {/* HEADER SECTION */}
      <Box
        display={smScreen ? "flex" : "block"}
        flexDirection={smScreen ? "row" : "column"}
        justifyContent={smScreen ? "space-between" : "start"}
        alignItems={smScreen ? "center" : "start"}
        m="20px 0"
      >
        <Header title="Menu Items" subtitle="Manage Restaurant Menu Items" />
        <Button
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            fontSize: "14px",
            fontWeight: "bold",
            padding: "10px 20px",
          }}
          onClick={handleOpen}
        >
          <Add sx={{ mr: "10px" }} />
          Add New Menu Item
        </Button>
      </Box>

      {/* TABLE */}
   <Box
  m="8px 0 0 0"
  sx={{
    ...tableStyle(colors),
    height: menuItemsList?.length > 0 ? "80vh" : "auto",
  }}
>
  {isLoading ? (
    <CircularProgress />
  ) : menuItemsList?.length > 0 ? (
    <MenuItemTable
      menuItems={menuItemsList}
      isLoading={isLoading}
      onEdit={handleEdit}
    />
  ) : (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Typography color="textSecondary">No menu items found</Typography>
    </Box>
  )}
</Box>


      {/* MODAL FORM */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Header
            title={editMode ? "EDIT MENU ITEM" : "ADD NEW MENU ITEM"}
            titleVariant="h4"
          />
          <MenuItemForm
            initialValues={selectedItem}
            onSubmit={handleFormSubmit}
            editMode={editMode}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default MenuItems;
